import { User, Role } from "../constants/interfaces";

export default (user: User, role: Role): boolean => {
  return (
    !!user.authorities &&
    !!user.authorities.find(({ authority }): any => authority === role)
  );
};

export const isUserOnlyAuthenticated = (user: User): boolean => {
  return (
    !!user.authorities &&
    user.authorities.length === 1 &&
    !!user.authorities.find(({ authority }): any => authority === Role.USER)
  );
};
